import React, { Component } from 'react';

class RouteEntry extends Component {

  constructor() {
    super();

    this.handleChange_id = this.handleChange_id.bind(this);
    this.handleChange_route = this.handleChange_route.bind(this);
    this.handleChange_url = this.handleChange_url.bind(this);
    this.handleChange_stripPrefix = this.handleChange_stripPrefix.bind(this);
    this.handleChange_ignoreHeaders = this.handleChange_ignoreHeaders.bind(this);
  }


  render() {
    return (
      <tr>


        <td className={!this.props.id ? 'align_left error' : 'align_left'}>
          <input
            placeholder="Route id..."
            value={this.props.id}
            onChange={this.handleChange_id}
          />
        </td>


        <td className={!this.props.route ? 'align_left error' : 'align_left'}>
          <input
            placeholder="Route route..."
            value={this.props.route}
            onChange={this.handleChange_route}
          />
        </td>


        <td className={!this.props.url ? 'align_left error' : 'align_left'}>
          <input
            placeholder="Route url..."
            value={this.props.url}
            onChange={this.handleChange_url}
          />
        </td>

        <td className="align_left">
        <input
            placeholder="Headers to Ignore"
            value={this.props.ignoreHeaders}
            onChange={this.handleChange_ignoreHeaders}
          />
        </td>

        <td className="align_left">
          <select value={this.props.stripPrefix} onChange={this.handleChange_stripPrefix}>
            <option value={true}>Yes</option>
            <option value={false}>No</option>
          </select>
        </td>


        <td onClick={() => { this.props.deleteRouteHandler(this.props.index) }}>
          <div className="blue_link">Remove</div>
        </td>


      </tr>
    );
  }

  handleChange_id(e) {
    let val = e.target.value;
    let entryProps = { ...this.props };


    let newValue = {
      id: val,
      route: this.props.route,
      url: this.props.url,
      ignoreHeaders: this.props.ignoreHeaders,
      stripPrefix: this.props.stripPrefix
    };

    this.props.updateRouteHandler(entryProps.index, newValue);
  }

  handleChange_route(e) {
    let val = e.target.value;
    let entryProps = { ...this.props };


    let newValue = {
      id: this.props.id,
      route: val,
      url: this.props.url,
      ignoreHeaders: this.props.ignoreHeaders,
      stripPrefix: this.props.stripPrefix
    };

    this.props.updateRouteHandler(entryProps.index, newValue);
  }

  handleChange_url(e) {
    let val = e.target.value;
    let entryProps = { ...this.props };


    let newValue = {
      id: this.props.id,
      route: this.props.route,
      url: val,
      ignoreHeaders: this.props.ignoreHeaders,
      stripPrefix: this.props.stripPrefix
    };

    this.props.updateRouteHandler(entryProps.index, newValue);
  }

  handleChange_stripPrefix(e) {
    let val = e.target.value;
    let entryProps = { ...this.props };


    let newValue = {
      id: this.props.id,
      route: this.props.route,
      url: this.props.url,
      ignoreHeaders: this.props.ignoreHeaders,
      stripPrefix: val
    };

    this.props.updateRouteHandler(entryProps.index, newValue);
  }

  handleChange_ignoreHeaders(e) {
    let val = e.target.value;
    let entryProps = { ...this.props };


    let newValue = {
      id: this.props.id,
      route: this.props.route,
      url: this.props.url,
      ignoreHeaders: val,
      stripPrefix: this.props.stripPrefix
    };

    this.props.updateRouteHandler(entryProps.index, newValue);
  }

}


export default RouteEntry;


// WEBPACK FOOTER //
// ./src/routes/components/PorletRoutesWidget/components/RouteEntry/index.js